import * as palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../../enums';
import { Label } from '@mlc/web-ui-toolkit';
import styled, { css } from 'styled-components';
import TrackableAnchor from '../../../../common/Anchor/TrackableAnchor';

export const Card = styled.div`
	@media (max-width: ${ScreenSize.medium}) {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		align-items: start;
		flex-direction: column;
	}
`;

export const Ul = styled.ul`
	margin-bottom: 1rem;
	margin-top: 1rem;
	min-width: 170px;
	padding: 0;

	li:first-child {
		border-top: 1px solid #4e4f4e;
	}

	@media (max-width: ${ScreenSize.medium}) {
		display: flex;
		justify-content: space-between;
		width: 68%;

		li {
			border-top: 1px solid #4e4f4e;
		}
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		flex-direction: column;
		width: 100%;

		li:last-child {
			border-top: none;
		}
	}
`;

export const Li = styled.li`
	align-items: center;
	border-bottom: 1px solid #4e4f4e;
	display: list-item;
	display: flex;
	justify-content: space-between;
	list-style: none;
	padding: 10px 0;

	@media (max-width: ${ScreenSize.medium}) {
		width: 49%;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		margin: 0;
		width: 100%;
	}
`;

interface AnchorProps {
	disabled?: boolean;
}

const enabledStyle = css`
	&:hover,
	&:focus {
		color: ${palette.mlcWhite};
		opacity: 1;
		text-decoration: underline;
	}
`;

const disabledStyle = css`
	color: ${palette.mlcWallaby};
	cursor: default;
	pointer-events: none !important;
`;

export const Anchor = styled(TrackableAnchor)`
	color: ${palette.mlcWhite};
	text-decoration: none;

	${(p: AnchorProps) => (p.disabled ? disabledStyle : enabledStyle)}
`;

export const WhiteLabel = styled(Label)`
	color: ${palette.mlcWhite};
	margin-top: 0;
`;
